import { Loader2 } from 'lucide-react';

type Props = {
  title: string;
  description?: string;
};

export const FullPageSpinner = ({ title, description }: Props) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center space-y-4 p-6 text-center">
      <Loader2 className="size-12 animate-spin text-primary" />
      <p className="text-lg font-medium text-foreground">{title}</p>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </div>
  );
};
